export const speciesCodeChange = function (event, reason) {
  console.log("species_code_change_event", event);
  console.log("species_code_change_reason", reason);

  let uomCode = "";
  if (this.state.trip_type === "1") {
    uomCode = "lbs";
    if (this.state.report_type === "3") {
      uomCode = "bu";
    }
  } else {
    uomCode = "cnt";
  }
  let newState = {
    species: "",
    speciesName: "",
    uom: uomCode,
  };
  if (reason) {
    //Save the new values when selected
    if (reason.hasOwnProperty("SPPCODE") && reason.hasOwnProperty("SPPNAME")) {
      if (reason.hasOwnProperty("REQUIRED_UOM")) {
        uomCode = reason.REQUIRED_UOM;
      } else {
        if (this.state.trip_type === "1") {
          uomCode = "lbs";
        } else {
          uomCode = "cnt";
        }
      }
      newState.species = reason.SPPCODE;
      newState.speciesName = reason.SPPNAME;
      newState.uom = uomCode;
    }
  }
  this.setState(newState);
};
export const getSelectedDisposition = function (species_code, return_type) {
  if (!species_code) {
    if (return_type === "array") {
      return [];
    }
    return "";
  }
  if (return_type === "array") {
    return [species_code];
  }
  return species_code;
};
export const getSpeciesName = function (species_code, speciesOptions) {
  if (!species_code) {
    return "";
  }
  if (
    !speciesOptions ||
    !Array.isArray(speciesOptions) ||
    speciesOptions.length === undefined
  ) {
    return "";
  }
  const species = speciesOptions.find(
    ({ SPPCODE }) => SPPCODE === species_code
  );
  if (species && species.hasOwnProperty("SPPNAME")) {
    return species.SPPNAME;
  }
  return "";
};

export const getRequiredUom = function (species_code, speciesOptions) {
  if (!species_code) {
    return false;
  }
  if (
    !speciesOptions ||
    !Array.isArray(speciesOptions) ||
    speciesOptions.length === undefined
  ) {
    return false;
  }
  const species = speciesOptions.find(
    ({ SPPCODE }) => SPPCODE === species_code
  );
  if (!species || Object.keys(species).length === 0) {
    return false;
  }
  if (species.hasOwnProperty("REQUIRED_UOM")) {
    return species.REQUIRED_UOM;
  }
  return false;
};

export const CatchEncRow = function () {
  this.species = null;
  this.kept = null;
  this.discarded = null;
  this.uom = null;
};
CatchEncRow.prototype.setSpecies = function (species) {
  this.species = species;
};
CatchEncRow.prototype.setKept = function (kept) {
  this.kept = kept;
};
CatchEncRow.prototype.setDiscarded = function (discarded) {
  this.discarded = discarded;
};
CatchEncRow.prototype.setUom = function (uom) {
  this.uom = uom;
};
